import React from "react";

const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("es-AR");
};

const TablaTerminalesExcepcionAnticipo = ({ data, loading, error, onEdit, onDelete }) => {
    if (loading) return <div className="tabla-loading">Cargando...</div>;
    if (error) return <div className="tabla-error">{error}</div>;
    if (!data || data.length === 0) return <div className="tabla-vacia">Sin datos</div>;

    const ordenado = [...data].sort((a, b) => a.id - b.id);

    return (
        <div className="bg-tabla-calculadora">
            <table className="table table-borderless table-hover">
                <thead className="bg-dark py-2">
                    <tr className="text-center tabla-thead text-white">
                        <th className="fs-12 lato-regular py-2 border-tabla-izquierda">ID</th>
                        <th className="fs-12 lato-regular py-2">Nro Terminal</th>
                        <th className="fs-12 lato-regular py-2">Fecha Alta</th>
                        <th className="fs-12 lato-regular py-2">Fecha Baja</th>
                        <th className="fs-12 lato-regular py-2">Estado</th>
                        <th className="fs-12 lato-regular py-2 border-tabla-derecha">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {ordenado.map((row) => (
                        <tr key={row.id} className="text-center">
                            <td className="fs-12 lato-regular py-2">{row.id}</td>
                            <td className="fs-12 lato-regular py-2">{row.nroTerminal}</td>
                            <td className="fs-12 lato-regular py-2">{formatDate(row.fechaAlta)}</td>
                            <td className="fs-12 lato-regular py-2">{formatDate(row.fechaBaja)}</td>
                            <td className="fs-12 lato-regular py-2">
                                {row.estaEliminado ? "Eliminado" : "Activo"}
                            </td>
                            <td className="fs-12 lato-regular py-2">
                                {row.estaEliminado ? (
                                    "-"
                                ) : (
                                    <div className="d-flex justify-content-center gap-2">
                                        <button className="btn btn-dark" onClick={() => onEdit(row)}>
                                            Editar
                                        </button>
                                        <button className="btn btn-dark" onClick={() => onDelete(row)}>
                                            Eliminar
                                        </button>
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TablaTerminalesExcepcionAnticipo;
